// extracted by mini-css-extract-plugin
export default {"answerTextCell":"QuestionCell-QuestionCell__answerTextCell--xwNgR","answerSelectMenu":"QuestionCell-QuestionCell__answerSelectMenu--SWhc0"};